"use client";

import { diligenciaItems } from "./constants";

import { NavWithSection } from "../nav-with-section";

import type { DiligenceItem } from "./diligence.types";

export const Diligence = ({ id, field, emptyElement }: DiligenceItem) => {
  return (
    <NavWithSection
      defaultValue="dividas"
      title="Diligência"
      items={diligenciaItems.map((item) => ({
        ...item,
        content: (props: DiligenceItem) =>
          item.content({ ...props, id, field, emptyElement }),
      }))}
    />
  );
};
